export const additionalFeaturesList = [
  {
    title: 'Product QnA',
    info:
      'Activate to enable Assistant responses to queries about product specifications.',
    value: false,
  },
  {
    title: 'Gen AI Followup',
    info:
      'Turn on to engage customers with follow-up preference questions post-recommendations.',
    value: false,
  },
  {
    title: 'Buying Guidance',
    info:
      'Enable to assist with inquiries related to brand blogs. Note: Requires AISS training on blogs',
    value: false,
  },
];

export const personalityList = [
  { title: 'Generic', value: 'generic' },
  { title: 'Casual', value: 'casual' },
  { title: 'Formal', value: 'formal' },
  { title: 'Funny', value: 'funny' },
];

export const mapPersonalityListValueToTitle = {
  generic: 'Generic',
  casual: 'Casual',
  formal: 'Formal',
  funny: 'Funny',
};

// Actions
export const ACTIONS = {
  SET_INITIAL_DATA: 'SET_INITIAL_DATA',
  UPDATE_BRAND_NAME: 'UPDATE_BRAND_NAME',
  UPDATE_PRODUCT_LIST: 'UPDATE_PRODUCT_LIST',
  UPDATE_CATALOGUE_ID: 'UPDATE_CATALOGUE_ID',
  UPDATE_REFRESH_RATE: 'UPDATE_REFRESH_RATE',
  UPDATE_ADDITIONAL_FEATURES: 'UPDATE_ADDITIONAL_FEATURES',
  UPDATE_PERSONALITY: 'UPDATE_PERSONALITY',
  UPDATE_EDIT_FLAG: 'UPDATE_EDIT_FLAG',
  UPDATE_ERRORS: 'UPDATE_ERRORS',
  SET_ACCORDIAN_ACTIVE: 'SET_ACCORDIAN_ACTIVE',
  SET_LOADING: 'SET_LOADING',
  SET_TRAINING_STATUS: 'SET_TRAINING_STATUS',
  AFTER_SAVE_STATE: 'AFTER_SAVE_STATE',
  AFTER_SAVE_STATE: 'AFTER_SAVE_STATE',
  SET_HSL: 'SET_HSL',
  SET_USER_KEY: 'SET_USER_KEY',
  SET_CATALOG_STORE_FILTER_KEY: 'SET_CATALOG_STORE_FILTER_KEY',
  SET_FILTER_TOGGLE: 'SET_FILTER_TOGGLE',
  SET_IS_FAQ_ALLOWED: 'SET_IS_FAQ_ALLOWED',
  SET_IS_FOLLOWUP_ALLOWED: 'SET_IS_FOLLOWUP_ALLOWED',
  SET_IS_BUYING_GUIDANCE_ALLOWED: 'SET_IS_BUYING_GUIDANCE_ALLOWED',
  SET_IS_SEARCH_ALLOWED: 'SET_IS_SEARCH_ALLOWED',
  SET_CUSTOM_PROMPTS_ACCORDION_ACTIVE: 'SET_CUSTOM_PROMPTS_ACCORDION_ACTIVE',
  SET_SYSTEM_PROMPT: 'SET_SYSTEM_PROMPT',
  SET_GPT_TO_ELASTIC_SEARCH_KEYS: 'SET_GPT_TO_ELASTIC_SEARCH_KEYS',
  SET_SEARCH_FUNCTION: 'SET_SEARCH_FUNCTION',
  SET_BUYING_GUIDANCE: 'SET_BUYING_GUIDANCE',
  SET_PRODUCT_QA: 'SET_PRODUCT_QA',
  SET_JSON_FUNCTIONS: 'SET_JSON_FUNCTIONS',
  SET_JSON_FUNCTIONS_ERROR: 'SET_JSON_FUNCTIONS_ERROR',
};

export const API_ACTIONS = {
  CREATE_CLIENT: 'create_client',
  TRAIN_CLIENT: 'train_client',
};

export const hslDefaultText =
  'Please verify your account to get product recommendations';

export const initialState = {
  isLoading: false,
  trainingStatus: '',
  brandName: '',
  productList: [],
  catalogId: '',
  refreshRate: { text: '12' },
  additionalFeatures: additionalFeaturesList,
  personality: {
    title: 'Formal',
    value: 'formal',
  },
  isEdit: false,
  afterSaveState: {
    state: '',
    subMessage: '',
    mainMessage: '',
  },
  isAdditionalFeatureAccordianActive: false,
  errors: {
    brandName: '',
    productList: '',
    catalogId: '',
    userKey: '',
    hsl: '',
  },
  hslValue: {
    text: hslDefaultText,
    type: 'TEXT',
  },
  userDetailsToggle: false,
  userKey: '',
  catalogFilterKey: { text: '' },
  catalogFilterList: [],
  isCustomizePromptsSearchSettingsAccordionActive: false,
  systemPrompt: '',
  gptFunctions: {},
  gptToElasticSearchKeys: [],
  defaultElasticSearchKeys: {},
  defaultGptFunctions: {},
  jsonFunctions: {
    search: null,
    buying_guidance: null,
    product_inquiry: null,
  },
  jsonFunctionError: {
    search: null,
    buying_guidance: null,
    product_inquiry: null,
  },
};
